import { LogicalDeviceWidgetEnum } from "../../enums/widget";
import { DeviceEntity } from "../device.entity";
import { DeviceLogicalWidget } from "./logical-widget";

export class SimulatorWidget extends DeviceLogicalWidget {
  constructor(device: DeviceEntity) {
    super(LogicalDeviceWidgetEnum.LOGICAL_DEVICE_WIDGET__SIMULATOR);
    this.subject = device;
  }
}
